import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const XTwitter = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        fill="inherit"
        d="m8.111 8.82 9.224 12.333L8.054 31.18h2.09l8.126-8.78 6.565 8.779h7.109l-9.742-13.026L30.84 8.82h-2.09l-7.483 8.085-6.046-8.085zm3.072 1.539h3.265L28.87 29.641h-3.265z"
      />
    </svg>
  );
};
